import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import { useIsTradeInApplied } from '~/context/common/TradeContext';
import PricingContext from '~/context/srp/PricingContext';

const useTradeToggled = () => {
  const isTradeInApplied = useIsTradeInApplied();
  const { setShouldUpdateTerms } = useContext(PricingContext);

  useSubsequentEffect(() => {
    setShouldUpdateTerms(true);
  }, [isTradeInApplied, setShouldUpdateTerms]);
};

export default useTradeToggled;
